import React, { useState } from 'react';
// material-ui
import { useTheme, styled } from '@mui/material/styles';
import {
    // Avatar,
    // Box,
    // Button,
    // Card,
    // CardContent,
    // ClickAwayListener,
    // Fade,
    // Link,
    // ListItemAvatar,
    // ListItemSecondaryAction,
    // Paper,
    // Stack,
    Chip,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemText,
    Popper,
    Typography
} from '@mui/material';

import axiosInstance from '../../../custom-axios';
import { toast } from 'react-toastify';
import ReactHtmlParser from 'react-html-parser';

//======= styles ========//
const ListItemWrapper = styled('div')(({ theme }) => ({
    cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

const UserNotificationList = (props) => {
    const theme = useTheme();
    const userId = localStorage.getItem('user_id');
    const [anchorEl, setAnchorEl] = useState(null);
    // const [notificationList, setNotificationList] = useState();
    const [notification, setNotification] = useState([]);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;
    const chipSX = {
        height: 24,
        padding: '0 6px'
    };
    const chipErrorSX = {
        ...chipSX,
        color: theme.palette.orange.dark,
        backgroundColor: theme.palette.orange.light,
        marginRight: '5px'
    };


    const clickNotification = (e, notificationId) => {
        // console.log(notificationId, notificationList);

        setAnchorEl(anchorEl ? null : e.currentTarget);

        let filterNotification = props.notificationList.filter((e, index) => {
            return e.notification_id == notificationId;
        });

        // console.log(filterNotification);

        setNotification(filterNotification);
    };

    const readNotification = async (e, notificationId) => {
        let finalData = {
            notification_id: notificationId,
            user_id: userId
        };

        let endPoint = `api/set-user-notification-status`;

        try {
            const response = await axiosInstance.post(endPoint, finalData);

            if (response.success) {
                // fetchAllAPI(); // comes from props
                // closePoper();
                props.fetchNotificationListApi()
                props.closePoper(false);
                toast.success(response.message);
            } else {
                toast.error(response.message);
            }

            // hideLoader();
        } catch (error) {
            toast.error(error.message);
        } finally {
            // hideLoader();
        }
    };

    // console.log(notification);

    // async function fetchAllAPI() {
    //     fetchNotificationList();
    // }

    // useEffect(() => {
    //     fetchAllAPI();
    // }, []);

    function NotificationPopper() {
        return (
            <Popper id={id} open={open} anchorEl={anchorEl} placement="left">
                <List
                    sx={{
                        width: '100%',
                        cursor: 'pointer',
                        maxWidth: 330,
                        backgroundColor: '#F3F3F3',
                        boxShadow: '3px 1px #41a3b0, -1px 0 1.2em #41a3b0',
                        transform: 'translate3d(-11px, 29px, 0px)',
                        py: 0,
                        borderRadius: '10px',
                        padding: '0px',
                        [theme.breakpoints.down('md')]: {
                            maxWidth: 300
                        },
                        '& .MuiListItemSecondaryAction-root': {
                            top: 22
                        },
                        '& .MuiDivider-root': {
                            my: 0
                        },
                        '& .list-container': {
                            pl: 7
                        }
                    }}
                >
                    {/*<ListItemWrapper>*/}
                    {notification?.map((rowValue) => {
                        return (
                            <>
                                <Grid
                                    container
                                    direction="column"
                                    className="list-container"
                                    onClick={(e) => readNotification(e, rowValue.notification_id)}
                                    sx={{ p: 10 }}
                                >
                                    <Grid item xs={12} sx={{ pb: 2 }}>
                                        <Typography variant="subtitle2">{ReactHtmlParser(rowValue.notification_message)}</Typography>
                                    </Grid>
                                </Grid>
                            </>
                        );
                    })}
                    {/*</ListItemWrapper>*/}
                </List>
            </Popper>
        );
    }

    return (
        <>
            <List
                sx={{
                    width: '100%',
                    maxWidth: 330,
                    py: 0,
                    borderRadius: '10px',
                    padding: '2px 10px 0 19px',
                    [theme.breakpoints.down('md')]: {
                        maxWidth: 300
                    },
                    '& .MuiListItemSecondaryAction-root': {
                        top: 22
                    },
                    '& .MuiDivider-root': {
                        my: 0
                    }
                }}
            >
                <NotificationPopper />

                {props.notificationList?.map((row) => {

                    let unreadNotificationColor = row.notification_status == 0 ? '#41a3b0' : ''
                    return (
                        <>
                            <ListItemWrapper aria-describedby={id} className='padding10px' onClick={(e) => clickNotification(e, row.notification_id)}>
                                <ListItem alignItems="center">
                                    <ListItemText primary={row.title} className="notification-title-ellipsis" sx={{ fontSize: '15px', color: unreadNotificationColor }} />

                                    <Grid>
                                        {row.notification_status == 0 ?
                                            <Grid item xs={12}>
                                                <Grid container>
                                                    <Grid item>
                                                        <Chip label="Unread" sx={chipErrorSX} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            : ''}
                                    </Grid>
                                </ListItem>
                            </ListItemWrapper>
                            <Divider className="divider" />
                        </>
                    );
                })}
            </List>
        </>
    );
};

export default UserNotificationList;
